import { render, staticRenderFns } from "./paypal.vue?vue&type=template&id=10da5f5c&scoped=true"
import script from "./paypal.vue?vue&type=script&lang=js"
export * from "./paypal.vue?vue&type=script&lang=js"
import style0 from "./paypal.vue?vue&type=style&index=0&id=10da5f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da5f5c",
  null
  
)

export default component.exports